import { render } from "./Token.vue?vue&type=template&id=67e24b4c"
import script from "./Token.vue?vue&type=script&lang=js"
export * from "./Token.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/auth/Token.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "67e24b4c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('67e24b4c', __exports__)) {
    api.reload('67e24b4c', __exports__)
  }
  
  module.hot.accept("./Token.vue?vue&type=template&id=67e24b4c", () => {
    api.rerender('67e24b4c', render)
  })

}


export default __exports__